import { Box, Flex, FormLabel, Tab, TabList, Tabs } from '@chakra-ui/react';
import FilterGroup from 'components/ui/FilterGroup';
import SearchBar from 'components/ui/SearchBar';
import SearchProvider from 'contexts/SearchContext';
import { PropsWithChildren } from 'react';
import { FiltersListProvider } from '../contexts/FiltersListContext';
import Filters from './Filters';
import { useSearchParams } from 'react-router-dom';

type ListsProps = PropsWithChildren<{
  searchParams?: object;
  dir?: 'row' | 'column';
}>;

export default function Lists({
  dir = 'row',
  children,
  searchParams,
}: ListsProps) {
  const [urlSearchParams, setUrlSearchParams] = useSearchParams();
  const defaultTabIndex = urlSearchParams.get('groupBy') === 'tag' ? 1 : 0;

  const onTabChange = (tabIndex: number) => {
    setUrlSearchParams(
      (prev) => {
        const params = new URLSearchParams(prev);
        params.set('groupBy', tabIndex === 1 ? 'tag' : 'company');
        return params;
      },
      { replace: true }
    );
  };

  return (
    <SearchProvider
      searchKey="lists"
      searchPath="/lists"
      searchParams={searchParams}
    >
      <FiltersListProvider>
        <Tabs
          isLazy
          variant="view"
          onChange={onTabChange}
          defaultIndex={defaultTabIndex}
        >
          {/* <Container flexDirection="column"> */}
          <Flex flexDir={dir} gap="20px">
            <FilterGroup justifyContent="space-between">
              <Box flex={1} minW="180px">
                <FormLabel>Buscar</FormLabel>
                <SearchBar placeholder="Buscar por nome da lista" mb={0} />
              </Box>
              <Filters />
            </FilterGroup>
          </Flex>

          <Box alignSelf="flex-start" mt="60px" w="200px">
            <FormLabel>Agrupar por</FormLabel>
            <TabList>
              <Tab>Por cliente</Tab>
              <Tab>Por tag</Tab>
            </TabList>
          </Box>
          {children}

          {/* </Container> */}
        </Tabs>
      </FiltersListProvider>
    </SearchProvider>
  );
}
